// formFields.js  
export const formFields = [  
    {  
      section: "From (Header)",  
      name: "parDscScheduleName",  
      label: "Schedule",  
      fieldLabel: "Schedule",  
      type: "text",  
      options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },  
      fieldNature: "Add:Read-Only",  
      position: [5, 22],  
      uppercase: true,  
    },  
    {  
      section: "From (Header)",  
      name: "parDscDescription",  
      label: "Description",  
      fieldLabel: "Description",  
      type: "text",  
      options: { maxLength: { value: 40, message: "MAXLENGTH_40" } },  
      fieldNature: "Add:Read-Only",  
      position: [6, 22],  
      uppercase: true,  
    },  
    {  
      section: "To (Header)",  
      name: "dtlDscScheduleName",  
      label: "Schedule",  
      fieldLabel: "Schedule",  
      type: "text",  
      options: { maxLength: { value: 10, message: "MAXLENGTH_10" }, required: { value: true, message: "REQUIRED" } },  
      fieldNature: "Add:Editable",  
      position: [9, 22],  
      uppercase: true,  
    },  
    {  
      section: "To (Header)",  
      name: "dtlDscDescription",  
      label: "Description",  
      fieldLabel: "Description",  
      type: "text",  
      options: { maxLength: { value: 40, message: "MAXLENGTH_40" }, required: { value: true, message: "REQUIRED" } },  
      fieldNature: "Add:Editable",  
      position: [10, 22],  
      uppercase: true,  
    },  
  ];  
  // screenInfo.js  
export const screenInfo = {  
    SCREEN_TITLE: "Copy Benefit Max Schedule",  
    SCREEN_NUMBER: "RCBSC004",  
  };  
  
  